"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardToNeoRhythm = exports.findIntensityKey = exports.findFrequencyKey = exports.findCoilKey = exports.neoRhythmToStandard = exports.customDurations = exports.KeyToCoil = exports.CoilDescriptionToKey = exports.KeyToCoilDescription = exports.IntensityToKey = exports.KeyToIntensity = exports.FreqToKey = exports.KeyToFreq = exports.ProgramToKey = exports.NeoRhythmCustom = exports.NeoRhythmPredefined = void 0;
const index_1 = require("./index");
const stimulation_1 = require("./stimulation");
const d3 = __importStar(require("d3-array"));
exports.NeoRhythmPredefined = [
    {
        id: '012323',
        name: 'Focus',
        program: 0,
        coil: 3,
        type: 'predefined',
        description: `Enhance mental capacity, 
      Beta and Gamma, 
      Fronto-temporal,
      Dominant 33.71Hz, Accompaying 54Hz`,
        usage: `Sink into a focused state, ideal for analytical work and problem solving.`,
    },
    {
        id: '15543',
        name: 'Energize',
        program: 1,
        coil: 3,
        type: 'predefined',
        description: `Energy and Vitality, 
      Gamma and Gamma, 
      Fronto-temporal,
      Dominant 40.5Hz, Accompaying 54Hz`,
        usage: `Energize your mind, ideal for a morning or late afternoon boost.`,
    },
    {
        id: '34316',
        program: 6,
        name: 'Consolidate',
        coil: 3,
        type: 'predefined',
        description: `Meditation Theta,
      Theta and Alpha,
      Temporal-Occipital (Parietal),
      Dominant 4Hz, Accompaying 10.67Hz`,
        usage: `Consolidate your thoughts, ideal for mindfulness meditation and reducing mind wandering.`,
    },
    {
        id: '73431',
        program: 7,
        name: 'Calm',
        coil: 3,
        type: 'predefined',
        description: `
      Calming and Synchronization,
      Alpha and Theta,
      Temporal-Occipital (Parietal),
      Dominant 9Hz, Accompaying 6Hz `,
        usage: `Calm your mind, ideal for winding down in the evening and gaining equanimity.`,
    },
];
exports.NeoRhythmCustom = [
    { name: 'Wm', intensity: 1, coil: 1, frequency: 6, description: 'WM', type: 'custom', id: '1623585668990' },
    { name: 'Test1', intensity: 1, coil: 1, frequency: 23, description: 'WM', type: 'custom', id: '1623585758060' },
];
exports.ProgramToKey = {
    focus: 0,
    energize: 1,
    consolidate: 6,
    meditate: 7,
};
// values in Hz
exports.KeyToFreq = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 7.83,
    9: 8,
    10: 9,
    11: 10.1,
    12: 11.3,
    13: 12,
    14: 13.5,
    15: 14.3,
    16: 16,
    17: 18,
    18: 20.25,
    19: 24,
    20: 27.3,
    21: 33.8,
    22: 40,
    23: 48,
    24: 50.57,
};
exports.FreqToKey = index_1.objectFlip(exports.KeyToFreq);
// values in mT
exports.KeyToIntensity = {
    1: 2.5,
    2: 0.5,
    3: 0.25,
};
exports.IntensityToKey = index_1.objectFlip(exports.KeyToIntensity);
exports.KeyToCoilDescription = {
    1: 'Front',
    2: 'Left & Right',
    3: 'All',
};
exports.CoilDescriptionToKey = index_1.objectFlip(exports.KeyToCoilDescription);
exports.KeyToCoil = {
    1: [0, 0, 1, 0, 0],
    2: [1, 1, 0, 1, 1],
    3: [1, 1, 1, 1, 1],
};
// Custom durations: 10-720 min mod 10
exports.customDurations = () => new Array(720 / 10).fill(1).map((_, i) => (i + 1) * 10);
function neoRhythmToStandard(program) {
    const { name, description, usage, coil, frequency, intensity, type } = program;
    if (type === 'predefined') {
        // TODO: map remaining programs
        switch (program.program) {
            case 0:
                return Object.assign(Object.assign({}, stimulation_1.StandardNeoRhythmPredefined.focus), { name, description, usage });
            case 1:
                return Object.assign(Object.assign({}, stimulation_1.StandardNeoRhythmPredefined.energize), { name, description, usage });
            default:
                return;
        }
    }
    if (!coil || !frequency || !intensity) {
        console.log('Parameters missing');
        return;
    }
    else {
        return {
            coils: exports.KeyToCoil[coil],
            frequency1: new Array(5).fill(exports.KeyToFreq[frequency]),
            frequency2: new Array(5).fill(0),
            intensity: new Array(5).fill(exports.KeyToIntensity[intensity]),
            type,
            name,
            description,
            usage,
            device: 'NeoRhythm',
        };
    }
}
exports.neoRhythmToStandard = neoRhythmToStandard;
function findCoilKey(coils) {
    const coil = Object.keys(exports.KeyToCoil).find((k) => index_1.arrayEquals(exports.KeyToCoil[Number(k)], coils));
    return coil ? Number(coil) : 3; // fallback to selecting all coils
}
exports.findCoilKey = findCoilKey;
function findFrequencyKey(frequencies) {
    const allFreqs = Object.keys(exports.FreqToKey).map(Number);
    const freq = index_1.closest(d3.max(frequencies), allFreqs); // closest match to max freq
    return Number(exports.FreqToKey[freq]);
}
exports.findFrequencyKey = findFrequencyKey;
function findIntensityKey(intensities) {
    const allInts = Object.keys(exports.IntensityToKey).map(Number);
    const intensity = index_1.closest(d3.max(intensities), allInts); // closest match to max intensity
    return Number(exports.IntensityToKey[intensity]);
}
exports.findIntensityKey = findIntensityKey;
function standardToNeoRhythm(program) {
    const { name, description, usage, coils, frequency1, intensity, type, code } = program;
    if (code && type === 'predefined') {
        return Object.assign({ program: Number(code), type }, exports.NeoRhythmPredefined.find((p) => p.program === Number(code)));
    }
    // custom programs
    return {
        coil: findCoilKey(coils),
        frequency: findFrequencyKey(frequency1),
        intensity: findIntensityKey(intensity),
        type,
        name,
        description,
        usage,
    };
}
exports.standardToNeoRhythm = standardToNeoRhythm;
//# sourceMappingURL=neorhythm-mapping.js.map